<template>
  <div class="page">
    <div class="content">
      <p v-if="!src && !url">登录中...</p>
      <template v-else>
        <div v-if="src && !showType">
          <div class="header">
            <template v-if="loginTip">
              微信扫码登录后<br />才能{{
                loginTip == 1
                  ? "选用活动模版"
                  : loginTip == 3
                  ? "领取权限"
                  : loginTip == 4
                  ? "同步已创建的答题活动"
                  : "创建答题活动"
              }}哟
            </template>
            <template v-else>
              微信扫码登录后<br />才能参与答题活动哟
            </template>
          </div>
          <img class="codeImg" :src="src" alt="" />
        </div>
        <div class="mobile-login" v-if="url && showType">
          <div class="title">
            登录后才能{{
              loginTip == 1
                ? "选用活动模版"
                : loginTip == 2
                ? "创建答题活动"
                : loginTip == 3
                ? "领取权限"
                : loginTip == 4
                ? "同步已创建的答题活动"
                : "参与答题活动"
            }}哟
          </div>
          <img
            src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20211013/2ec8956486a4561b787e8cc18b8d9f1a.svg"
            alt=""
          />
          <div class="login-btn" @click="openwx">一键登录</div>
        </div>
        <div v-if="isMobile">
          <p class="tips" @click="changeLoginType">
            {{ showType ? "点击没反应？点我试试扫码登录" : "使用一键打开" }}
          </p>
        </div>
        <!-- <p class="tips">
          登录即表示同意<span @click="toFile('terms')">使用协议</span>和<span
            @click="toFile('privacy')"
            >隐私协议</span
          >
        </p> -->
        <Contact :fixed="true" />
      </template>
    </div>
  </div>
</template>
<script>
import {
  randomString,
  isMobile,
  getToken,
  verifyAuth,
  reLogin
} from "@/utils/common";
import questionOnly from "@/utils/questionOnly";
import Contact from "@/components/contact";
import api from "@/utils/api";
import { Toast, Dialog } from "vant";
import { handleZI } from "../../utils/common";
let intervalAsk = null;
let checkTime = 0;
export default {
  components: { Contact },
  data() {
    return {
      src: "",
      errcode: "",
      config: "",
      loginTip: false,
      url: "",
      fromRoute: "",
      isMobile: isMobile(),
      showType: 0,
      auth_code: "",
      isInApp: window.wemeet.app.isTMWebview()
    };
  },
  async mounted() {
    if (this.isInApp) {
      this.showType = this.isMobile;
      let loginStatus = await verifyAuth();
      if (!loginStatus) return reLogin();
      this.loginTip = localStorage.getItem("loginTip") || 0;
      if (localStorage.getItem("bind_status") == 1) {
        Toast("登录成功");
        setTimeout(() => {
          if (this.loginTip == 3) {
            localStorage.setItem("showVipModal", true);
            this.$router.push({ name: "intro" });
          } else {
            if (localStorage.getItem("showVipModal"))
              localStorage.removeItem("showVipModal");
            if (localStorage.getItem("loginTip"))
              localStorage.removeItem("loginTip");
            this.$router.replace({ name: "questionList" });
          }
        }, 600);
      } else {
        this.getAuthInfo();
      }
    }
    // history.pushState(null, null, document.URL);
    // window.addEventListener("popstate", this.disableBrowserBack);
  },
  destroyed() {
    if (this.loginTip) localStorage.removeItem("loginTip");
    // window.removeEventListener("popstate", this.disableBrowserBack, false);
  },
  methods: {
    copySuccess() {
      Toast("复制成功");
    },
    disableBrowserBack() {
      this.$router.push({ name: "questionList" });
    },
    async changeLoginType() {
      this.showType = !this.showType;
    },
    openwx() {
      window.location.href = this.url;
    },
    toFile(type) {
      this.$router.push({ name: type });
    },
    requestAuth() {
      let state = randomString(16);
      window.wemeet.permission.requestAuth({
        sdkId: api.sdkId,
        corpId: 213872664,
        redirectURI: "https://" + api.hostName + ".xiaoxiaodati.com/login",
        state
      });
    },
    getAuthInfo() {
      let param = {
        access_token: getToken(),
        ref_url: window.location.href,
        code_type: this.loginTip == 1 ? 4 : 3,
        app_type: api.test ? 1 : 0,
        source: 2
      };
      questionOnly.get("/xcx/ques/v2/meeting/callback", param).then(res => {

        if (res.sta == 0) {
          if (res.data.access_token) {
            this.handleLogin(res.data);
            localStorage.setItem("bind_status", 1);
          } else {
            this.url = res.data.url || "";
            this.src = res.data.qrcode || "";
            this.checkLoginSuccess(res.data.random_key, res.data.access_token);
          }
        } else if ((res.sta == -1 && res.errcode === 109) || res.sta == -500) {
          // Dialog.alert({
          //   message: JSON.stringify(param) + JSON.stringify(res)
          // })
          Toast("身份已过期请重新授权登录");
          setTimeout(() => {
            this.requestAuth();
          }, 1000);
        } else {
          Toast(res.msg);
        }
      });
    },
    checkLoginSuccess(random_key, access_token) {
      if (intervalAsk) clearTimeout(intervalAsk);
      checkTime++;
      if (checkTime > 190 || this.$route.name != "login") {
        checkTime = 0;
        intervalAsk = null;
        return;
      }
      let parm = {
        random_key,
        access_token,
        app_type: api.test ? 1 : 0,
        loadingMsg: 'no'
      };
      questionOnly.get(api.question.checkBindStatus, parm).then(async res => {
        if (res.sta === 0) {
          if (!res.data.status) {
            clearTimeout(intervalAsk);
            intervalAsk = setTimeout(() => {
              this.checkLoginSuccess(random_key, access_token);
            }, 3000);
          } else {
            this.handleLogin(res.data);
          }
        } else {
          clearTimeout(intervalAsk);
          intervalAsk = null;
          Toast(res.msg);
        }
      });
    },
    handleLogin(data) {
      localStorage.setItem("bind_status", 1);
      Toast("登录成功");
      if(localStorage.getItem('fail_count')) localStorage.removeItem('fail_count')
      localStorage.setItem("token", data.access_token);
      handleZI(data.mp_openid)
      setTimeout(() => {
        if (this.loginTip == 3) {
          localStorage.setItem("showVipModal", true);
          this.$router.push({ name: "intro" });
        } else {
          if (localStorage.getItem("showVipModal"))
            localStorage.removeItem("showVipModal");
          if (localStorage.getItem("loginTip"))
            localStorage.removeItem("loginTip");
          this.$router.replace({ name: "questionList" });
        }
      }, 600);
    }
  }
};
</script>
<style lang="scss" scoped>
@function rem($px) {
  @return $px / 75 + rem;
}
.page {
  background: #fff;
  height: auto;
  min-height: 100vh;
  padding-top: 64px;
  box-sizing: border-box;
}
.content {
  text-align: center;
  font-size: rem(32);
  .header {
    padding: rem(60) 0;
    word-wrap: break-word;
    word-break: normal;
  }
  .codeImg {
    width: rem(420);
    height: rem(420);
  }
  .tips {
    font-size: rem(24);
    margin: rem(30) 0 rem(30);
    span {
      color: #1890ff;
      text-decoration: underline;
      cursor: pointer;
    }
  }
}
.imgGroup {
  display: flex;
  align-items: center;
  img {
    width: rem(311);
    height: rem(282);
    margin-bottom: rem(30);
  }
  img:first-child {
    margin-right: rem(12);
  }
}
.refreshImg {
  width: rem(420);
  height: rem(274);
  display: block;
  margin: 0 auto;
}
.info {
  text-align: left;
  margin: rem(60) rem(60) 0;
  font-size: rem(28);
  line-height: rem(42);
  color: #262626;
  .title {
    font-weight: 700;
    font-size: rem(34);
    line-height: rem(51);
    margin-bottom: rem(30);
  }
  .desc {
    margin-bottom: rem(30);
  }
}
.login-btn {
  height: rem(86);
  line-height: rem(86);
  background: #1890ff;
  color: #fff;
  font-size: rem(32);
  border-radius: rem(8);
  cursor: pointer;
  margin: rem(80) rem(30) 0;
}
.mobile-login {
  text-align: center;
  .title {
    font-weight: 700;
    font-size: rem(40);
    margin-bottom: rem(80);
  }
  img {
    width: rem(120);
    height: rem(120);
  }
}
.tips {
  text-align: center;
  margin-top: rem(30);
  color: #999999;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/mindex.vue